/*
 * @Author: cc
 * @Date: 2021-01-21 10:30:33
 * @LastEditTime: 2021-01-21 11:44:45
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\manageConfig\tenantManageMent\topicManage\topic.js
 * @Description:  选题管理页面
 */
angular.module('tenantTopicManageModule', []).controller('tenantTopicManageCtrl', [
    '$scope',
    '$sessionStorage',
    'trsHttpService',
    'modalDialog',
    function (
        $scope,
        $sessionStorage,
        trsHttpService,
        modalDialog
    ) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.params = {
                serviceid: 'mlf_tenant',
                methodname: 'switchReportAudit',
                SwitchReportAudit: $sessionStorage.get('curUserInfo') ? JSON.parse($sessionStorage.get('curUserInfo').SWITCHREPORTAUDIT) : false,
            };
        }

        /**
         * [switch description] 切换开关
         * @return  {[type]}  [return description]
         */
        $scope.switch = function () {
            modalDialog.confirmModal('提示信息', '确定改动审核？', function () {
                $scope.params.SwitchReportAudit = !$scope.params.SwitchReportAudit;
                requestData();
            });
        };

        /**
         * [requestData description] 数据请求
         * @return  {[type]}  [return description]
         */
        function requestData() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get')
                .then(function () {
                    modalDialog.alertType('操作成功', '', 'success', false);
                });
        }
    }]);
